import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'react'
import Header from './components/Header'
import TemplateList from './components/TemplateList'
import TemplateDetail from './components/TemplateDetail'
import AdminPanel from './components/AdminPanel'
import AdminLogin from './pages/AdminLogin'
import ProtectedRoute from './components/ProtectedRoute'
import './App.css'

const queryClient = new QueryClient()

function App() {
  const [selectedTemplates, setSelectedTemplates] = useState<number[]>([])

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Header selectedTemplates={selectedTemplates} setSelectedTemplates={setSelectedTemplates} />
          
          <main className="container mx-auto px-4 py-8">
            <Routes>
              <Route 
                path="/" 
                element={
                  <TemplateList 
                    selectedTemplates={selectedTemplates}
                    setSelectedTemplates={setSelectedTemplates}
                  />
                } 
              />
              <Route path="/template/:id" element={<TemplateDetail />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute>
                    <AdminPanel />
                  </ProtectedRoute>
                } 
              />
            </Routes>
          </main>
        </div>
      </Router>
    </QueryClientProvider>
  )
}

export default App